import { request } from './request.js'

export const getBrowseCount = () => request.get('browse-counts')
export const plusBrowseCount = () => request.post('browse-counts')
